/**
 * Created by charnjeetelectrovese@gmail.com on 12/5/2019.
 */

// import { serviceFetchProviderRequests } from '../services/ProviderRequest.service';
// import { fetchPRequests } from '../services/User.service';
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateGeofence, serviceGetGeofence, serviceUpdateGeofence,serviceDeleteGeofence} from "../services/Geofence.service";

export const FETCH_INIT = 'FETCH_INIT_GEOFENCE';
export const FETCHED = 'FETCHED_GEOFENCE';
export const FETCHED_FAIL = 'FETCHED_FAIL_GEOFENCE';
export const FETCHED_FILTER = 'FETCHED_FILTER_GEOFENCE';
export const FETCH_NEXT = 'FETCH_NEXT_GEOFENCE';
export const FILTER = 'FILTER_GEOFENCE';
export const RESET_FILTER = 'RESET_FILTER_GEOFENCE';
export const SET_SORTING = 'SET_SORTING_GEOFENCE';
export const SET_FILTER = 'SET_FILTER_GEOFENCE';
export const SET_PAGE = 'SET_PAGE_GEOFENCE';
export const CHANGE_PAGE = 'CHANGE_PAGE_GEOFENCE';
export const CHANGE_STATUS= 'CHANGE_STATE_GEOFENCE';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_GEOFENCE';
export const CREATE_DATA = 'CREATE_GEOFENCE';
export const UPDATE_DATA = 'UPDATE_GEOFENCE';
export const DELETE_ITEM = 'DELETE_GEOFENCE';
export const DRAG_ITEM = 'DRAG_GEOFENCE';

export function actionFetchGeofence(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetGeofence({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionCreateGeofence(data) {
    const request = serviceCreateGeofence(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateGeofence(data) {
    const request = serviceUpdateGeofence(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteGeofence(id) {
    const request = serviceDeleteGeofence({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageGeofenceRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

// export function nextPRequestsClick() {
//     return {
//         type: NEXT_PREQUESTS,
//         payload: null,
//     };
// }
//
// export function prevPRequestsClick() {
//     return {
//         type: PREV_PREQUESTS,
//         payload: null,
//     };
// }

export function actionFilterGeofence(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusGeofence(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
        // request.then((data) => {
        //     dispatch({type: FILTER_PREQUESTS, payload: data});
        //     dispatch({type: FETCHED_PREQUESTS, payload: null});
        // });
    };
}

export function actionResetFilterGeofence() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionDragGeofence(dragId, dragOverId) {
    return {
        type: DRAG_ITEM,
        payload: {dragId, dragOverId}
    }
}

export function actionSetPageGeofence(page) {
    const stateData = store.getState().geofence;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchGeofence(serverPage + 1, sortingData, {query, query_data: queryData}));
        // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    }


    return {
        type: CHANGE_PAGE,
        payload: page,
    };
    // if (this.props.totalUsers <= ((this.props.currentPage + 1) * 100)) {
    //         // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order);
    //         this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
    //     }

}
